module.exports = __webpack_public_path__ + "img/fig18.d4927da3.jpg";